import { Component, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { RequestsService } from 'src/app/utils/services/requests.service';
import { ToasterComponent } from 'src/app/utils/services/toaster/toaster.component';
import { LoaderComponent } from '../loader/loader.component';
import { apiUrls } from 'src/environments/environment';
import { Capacitor } from '@capacitor/core';
import { AppPurchase } from 'src/app/utils/services/app-purchase';

interface QrcodeResponse {
  id: string;
  qrcode: string;
  name: string;
  description: string;
  news: true;
  sides: [
    any
  ];
  lightArtistDto: {
    id: string;
    publicName: string;
    profilePicture: string;
  };
}

@Component({
  selector: 'app-modal',
  templateUrl: './modal.page.html',
  styleUrls: ['./modal.page.scss'],
})
export class ModalComponent implements OnInit {
  assetsApi = apiUrls.assetsApi;
  public props: QrcodeResponse;

  constructor(private modalController: ModalController, public navParams: NavParams,
    private request: RequestsService, private toaster: ToasterComponent, private navCtrl: NavController,
    private translate: TranslateService, private loader: LoaderComponent, private appPurchase: AppPurchase) { }

  ngOnInit() {
    this.props = this.navParams.data as QrcodeResponse;
  }

  dismissModal() {
    // using the injected ModalController this page
    this.modalController.dismiss();
  }

  async freeSubscribe() {
    if (Capacitor.getPlatform() !== 'ios') {
      const message = await this.translate.get('charging').toPromise();
      await this.loader.presentLoading(message + '...');

      this.request.activateQrcode(this.props.qrcode)
        .then(() => {
          this.toaster.successToast('scan_successfull');
          this.navCtrl.navigateRoot('/vinyl/' + this.props.id);
        })
        .catch(() => {
          this.toaster.errorToast('vinyl_already_used');
        })
        .finally(async () => {
          await this.loader.dismiss();
          await this.modalController.dismiss();
        });
    } else {
      this.appPurchase.orderProduct(this.appPurchase.getProducts()[1], this.props);
    }
  }
}
